const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const fmtQty = (value) => {
  const number = Number(value || 0);
  if (!Number.isFinite(number)) return "";
  if (Math.abs(number - Math.trunc(number)) < 0.000001) return `${Math.trunc(number)}`;
  return number.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

export const getPrintTemplate = ({ headerInfo, rows = [], totals }) => {
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="center">${escapeHtml(row.date || "")}</td>
        <td>${escapeHtml(row.sellerName || "")}</td>
        <td class="right">${fmtQty(row.openingQty)}</td>
        <td class="right">${fmtQty(row.fromWarehouseQty)}</td>
        <td class="right">${fmtQty(row.otherQty)}</td>
        <td class="right">${fmtQty(row.totalQty)}</td>
        <td class="right">${fmtQty(row.soldQty)}</td>
        <td class="right">${fmtMoney(row.soldAmount)}</td>
        <td class="right">${fmtQty(row.otherOutQty)}</td>
        <td class="right">${fmtMoney(row.otherOutAmount)}</td>
        <td class="right">${fmtQty(row.endingQty)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Thẻ Quầy Hàng</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:26px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; margin-top:6px; }
        table { width:100%; border-collapse:collapse; margin-top:10px; font-size:14px; }
        th, td { border:1px solid #000; padding:4px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .signatures { margin-top:22px; display:flex; justify-content:flex-end; text-align:center; }
        .sign-col { width:35%; }
        .sign-spacer { height: 16px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Địa chỉ:</b> ${escapeHtml(headerInfo.address || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 02 - BH</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">THẺ QUẦY HÀNG</div>
      <div class="subtitle">Ngày lập thẻ ${escapeHtml(headerInfo.documentDate || ".../.../....")} - Tờ số: ${escapeHtml(headerInfo.sheetNumber || "")}</div>

      <div class="subtitle" style="text-align:left; margin-top:10px; line-height:1.6;">
        - Tên hàng: ${escapeHtml(headerInfo.itemName || "")} &nbsp;&nbsp; Quy cách: ${escapeHtml(headerInfo.specification || "")}
        <br/>- Đơn vị tính: ${escapeHtml(headerInfo.unitName || "")} &nbsp;&nbsp; Đơn giá: ${fmtMoney(headerInfo.unitPrice || 0)}
      </div>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Ngày tháng</th>
            <th rowspan="2">Tên người bán hàng</th>
            <th rowspan="2">Số lượng tồn đầu ngày (ca)</th>
            <th rowspan="2">Số lượng nhập từ kho trong ngày (ca)</th>
            <th rowspan="2">Số lượng nhập khác trong ngày (ca)</th>
            <th rowspan="2">Cộng tồn đầu ngày (ca) và nhập trong ngày (ca)</th>
            <th colspan="2">Xuất bán</th>
            <th colspan="2">Xuất khác</th>
            <th rowspan="2">Số lượng tồn cuối ngày (ca)</th>
          </tr>
          <tr>
            <th>Lượng</th>
            <th>Tiền</th>
            <th>Lượng</th>
            <th>Tiền</th>
          </tr>
          <tr>
            <th>A</th><th>B</th><th>1</th><th>2</th><th>3</th><th>4 = 1+2+3</th><th>5</th><th>6</th><th>7</th><th>8</th><th>9 = 4-5-7</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="2" class="center"><b>Cộng</b></td>
            <td class="right"><b>${fmtQty(totals?.openingQty || 0)}</b></td>
            <td class="right"><b>${fmtQty(totals?.fromWarehouseQty || 0)}</b></td>
            <td class="right"><b>${fmtQty(totals?.otherQty || 0)}</b></td>
            <td class="right"><b>${fmtQty(totals?.totalQty || 0)}</b></td>
            <td class="right"><b>${fmtQty(totals?.soldQty || 0)}</b></td>
            <td class="right"><b>${fmtMoney(totals?.soldAmount || 0)}</b></td>
            <td class="right"><b>${fmtQty(totals?.otherOutQty || 0)}</b></td>
            <td class="right"><b>${fmtMoney(totals?.otherOutAmount || 0)}</b></td>
            <td class="right"><b>${fmtQty(totals?.endingQty || 0)}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người lập</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
